/**
 * These names are given to by the client, do not change.
 */ export var DirectCallRules;
(function(DirectCallRules) {
    DirectCallRules["NAME_PAGE_VIEW"] = "page_view";
    DirectCallRules["NAME_INITIAL_PAGE_LOAD"] = "initial_page_load";
    DirectCallRules["LOAD_INITIAL"] = "load_initial";
    DirectCallRules["LOAD_MORE"] = "load_more";
})(DirectCallRules || (DirectCallRules = {}));
